import * as React from 'react'
import Image from 'next/image'
import { motion } from 'framer-motion'
import { PartialContainer } from 'components'
import Styles from './inflation-content.module.css'
export const InflationHedgeContent = ({
  heading,
  subHeading,
  description,
  imageUrl,
  reverse,
}: {
  heading: string
  subHeading: string
  description: string
  imageUrl: any
  reverse?: boolean
}) => {
  return (
    <PartialContainer>
      <div className="pt-8 lg:px-32 lg:pt-24">
        <div className="mx-auto mb-5 flex w-full flex-col items-center justify-center px-6 lg:mb-7 lg:w-[82%] lg:px-0">
          <h1
            className={`${Styles?.leadingXl} text-center font-heading text-2xl font-extrabold text-[#282231] lg:text-5xl`}>
            {heading || ''}
          </h1>
          <p className="pt-4 text-center font-heading text-lg font-semibold text-[#374151]">
            {subHeading || ''}
          </p>
        </div>
        <div
          className={`flex items-center justify-between ${
            reverse
              ? 'flex-col-reverse lg:flex-row-reverse'
              : ' flex-col lg:flex-row'
          }`}>
          <div className={`w-full lg:w-[47%] ${Styles.content}`}>
            <motion.div
              initial={{
                opacity: 0,
                x: -40,
              }}
              viewport={{ once: true }}
              whileInView={{
                opacity: 1,
                x: 0,
              }}
              transition={{
                duration: 0.5,
                delay: 0.1,
              }}
              className="mt-4 text-[#58595B] lg:my-16 lg:text-base"
              dangerouslySetInnerHTML={{ __html: description }}></motion.div>
          </div>
          <div className="w-full lg:w-[45%]">
            <motion.div
              initial={{
                opacity: 0,
              }}
              viewport={{ once: true }}
              whileInView={{
                opacity: 1,
              }}
              transition={{
                duration: 0.5,
                delay: 0.2,
              }}
              className="relative h-full min-h-[389px] w-full">
              <Image
                src={imageUrl}
                alt={'inflation-hedge'}
                fill
                priority
                className="z-0 object-contain"
              />
            </motion.div>
          </div>
        </div>
      </div>
    </PartialContainer>
  )
}
